import React from "react";
import { Box, Typography } from "@mui/material";
import "../style/prizes.scss";
import "../style/global.scss";
import prizes from "../store/dec2023/prizes.json";
import books from "../store/dec2023/prizeBooks.json";
import amazonEchoImg from "../assets/prizes/1.webp";
import headphonesImg from "../assets/prizes/2.webp";
import watchImg from "../assets/prizes/3.webp";
import { Link } from "react-router-dom";

const Prizes = ({ theme }) => {
  const prizes = [
    {
      title: "1ST WINNER",
      description: "Amazon Echo Spot (Latest Model)",
      image: amazonEchoImg,
      link: "https://www.amazon.in/All-new-Echo-Spot--Smart-alarm-clock-with-Alexa-and-Bluetooth/dp/B0C2S39V9Y/ref=sr_1_2_sspa?crid=1F0MG4JUITGLN&dib=eyJ2IjoiMSJ9.4T7l32B9gsf7E5xBXAd0ObSA8SyJ0YkaWMXEbFxFSRhqoGWSPc-FcSq-3366AOhUZb3ZDjzNbT8E4YVdMIXJQHKc0vjQicDaTczrtQT9l1oGNXRjGo4VK6hIbuGIknQs_6UDRVh80RlRu8dX1WmTF03bzXIUjrWNM9DH0XmDYhpTdKLZ59nE-tjXMpwCnwLHzoM_ihAvoXAKoL-TwSI1fohTUky9IVjfvAmR6p0_sAU.t2H0XgtGRl0B8tmIythUw7LjJfQt2h2neCI_JxHMwM0&dib_tag=se&keywords=amazon%2Becho%2Bdot%2B5th%2Bgen%2Bwith%2Bclock&nsdOptOutParam=true&qid=1750157260&sprefix=amazon%2Becho%2Caps%2C315&sr=8-2-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9hdGY&th=1",
    },
    {
      title: "2ND WINNER",
      description: "Sony Wireless Headphones",
      image: headphonesImg,
      link: "https://www.amazon.in/Sony-Bluetooth-Headphones-Multipoint-Connectivity/dp/B0BS1PRC4L/ref=sr_1_18?crid=19BBZIVWN2O1K&dib=eyJ2IjoiMSJ9.q2Kgg5xEYUB-dt5MqOHb4MlinH_Kc6yFJFQS9_mCifR22wzObUDcxS2T6-InoD2TvYO1jP-ASGXL-4Xs8KUBroZNcy3mvP7Fr89ZlIxoyK0fSI5i-vBGrz4fieN3vbC6G7V_Koe2T6IASaFEEB7CUu4BnXePfypklI7z9vbaOLM8HLf3klm6y6DcqaCpPvRHAVDZIiNickWSrbJJJDWoDGiHFY7VhK5mZMl_1yCkR74.i9k2SNqgc1pWAyrS4jDHdgHy6dwrHxE-LT67mXH911M&dib_tag=se&keywords=bluetooth%2Bheadphones%2Bwireless&qid=1750157761&sprefix=bluetooth%2B%2Caps%2C322&sr=8-18&th=1",
    },
    {
      title: "3RD WINNER",
      description: "Fastrack Fs2 Pro Smart Watch",
      image: watchImg,
      link: "https://www.amazon.in/Fastrack-Smartwatch-Resolution-Singlesync-Watchfaces/dp/B0CPLPYPCL/ref=sr_1_7?crid=DYKMTBELEDWS&dib=eyJ2IjoiMSJ9.bwfno6YqTh60gZySsv9HFRE2e_Qn6FkkqUeGurLNaqIs1EPZOfClfqVGzGzb9GqSeHducwjNYLJcHB-_pcGLTFAj6yA7LVaWSolBJqGqfSt0JGPPQW-IW2cYisxQXu7Zmps0L61eLSQ2pziez-ly4JBwyggQlQ65HXS2yi1xwCrJURz-_bLaVDcoWY15q2JxlX_07EycJFnPEg3-k1lNvzfYNXC2nqWilu0bvzuckrE.e9T6vg5p6OtmIl498DKRELrc-xGanGPxDAEUUSFNXp8&dib_tag=se&keywords=fastrack+smartwatch+unisex&nsdOptOutParam=true&qid=1750157659&sprefix=fastrack+smartwatch+unise%2Caps%2C259&sr=8-7",
    },
  ];

  return (
    <div className="prizes">
      <div className="prizesHeadingSection">
        <h3 className="prizesHeading">WIN EXCITING PRIZES WORTH UPTO 60K</h3>
        <p className="prizesDescription">
          We have an exciting quiz competition for all the attendees. Be part of
          our event, attend <br /> sessions, participate in the quiz
          competition, and win exciting prizes!
        </p>
      </div>

      <div className="prizeList-wrapper">
        {prizes.map((data, idx) => {
          return (
            <Link
              to={data.link}
              target="_blank"
              key={idx}
              className="prizeCard"
            >
              <div className="prizeNo">
                {idx + 1}
                <sup>st</sup>
              </div>
              <div className="prizeInfo">
                <div className="prizeInfoHeading"> {data.title}</div>
                <div className="prizeInfoDescription">{data.description}</div>
              </div>
              <div className="prizeImgWrapper">
                <img src={data.image} alt="prize" className="prizeImg" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
export default Prizes;
